'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunicationTextsms = function CommunicationTextsms(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
  );
};
CommunicationTextsms = (0, _pure2.default)(CommunicationTextsms);
CommunicationTextsms.displayName = 'CommunicationTextsms';
CommunicationTextsms.muiName = 'SvgIcon';

exports.default = CommunicationTextsms;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/communication/textsms.js
 ** module id = 1768
 ** module chunks = 0
 **/